import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAppraisalHtmlPostActions,
  // setThePerformsAgentRetrieveACtion,
  SetTheAppraisalRetrieveDatasActions,
  setThePerformsAgentEditACtion,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/User/Appraisal.scss";
import { Button } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import UDSprofile from "../../../Assets/AppComponent/UDSAppraisal.jpg";
import { retry } from "redux-saga/effects";
const AppraisalPerform = React.forwardRef((props, ref) => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const { setshow, setEditIds, year, month ,editIds } = props;

  const componentRef = useRef(null);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [Revenuepercent, setrevenuePercen] = useState();
  //-----Get0-----html---------
  useEffect(() => {
    if (editIds != "" && state.clientDetailsCall.ActiveForUserProfile == 3) {
      const payload = {
        // EditId: state.ClientBranchIDs.userProfileId,
        EditId: editIds,
      };

      //  dispatch(setThePerformsAgentRetrieveACtion(payload));
      dispatch(SetTheAppraisalRetrieveDatasActions(payload));
    }
  }, [editIds , state.clientDetailsCall.ActiveForUserProfile]);

  ///---set The Past Years  and Current Year
  const [pastYear, setPastYear] = useState("");
  const [currentYear, setCurrentYear] = useState("");

  useEffect(() => {
    const currentDate = new Date();
    const pastYearValue = currentDate.getFullYear() - 1;
    const currentYearValue = currentDate.getFullYear();
    setPastYear(pastYearValue);
    setCurrentYear(currentYearValue);
  }, []);

  ///---
  
  // useEffect(() => {
  //   if (
  //     setEditIds != "" &&
  //     setEditIds == state.AppraisalSliceDatasss.AppraisalDatasLists.id &&
  //     state.AppraisalSliceDatasss.AppraisalDatasLists != null
  //   ) {
  //   console.log(state.AppraisalSliceDatasss.AppraisalDatasLists ,"state.AppraisalSliceDatasss.AppraisalDatasLists", setEditIds);
    
  //      if(state.AppraisalSliceDatasss.AppraisalDatasLists.perform_html != undefined &&
  //         state.AppraisalSliceDatasss.AppraisalDatasLists.perform_html != null 
  //       ){ 
  //     const decodedObject = JSON.parse(
  //       state.AppraisalSliceDatasss.AppraisalDatasLists.perform_html
  //     );

  //           setBusiness({
  //       ...Business,
  //       BusinessHeader:decodedObject.datas.Business.BusinessHeader,
  //       Revenue:decodedObject.datas.Business.Revenue,
  //       EBITDA:decodedObject.datas.Business.EBITDA,
  //       NewBusiness:decodedObject.datas.Business.NewBusiness,
  //       NewLogos:decodedObject.datas.Business.NewLogos,
  //       Collections:decodedObject.datas.Business.Collections,
  //       CustomerRetention:decodedObject.datas.Business.CustomerRetention,
  //       RevenueProfitLeakage:decodedObject.datas.Business.RevenueProfitLeakage ,
  //       TechnologyDeployment :decodedObject.datas.Business.TechnologyDeployment,

  //     })
  //     setOperational({
  //       ...Operational ,
  //       OperationalMetrics:decodedObject.datas.Operational.OperationalMetrics,
  //       TimelyAttendance:decodedObject.datas.Operational.TimelyAttendance,
  //       TimelyPayroll:decodedObject.datas.Operational.TimelyPayroll,
  //       Timelyinoicing:decodedObject.datas.Operational.Timelyinoicing,
  //       FillRates:decodedObject.datas.Operational.FillRates,
  //     })
  //     setCompliance({
  //       ...Compliance,
  //       Compliancedatas:decodedObject.datas.Compliance.Compliancedatas,
  //       ESIpayments:decodedObject.datas.Compliance.ESIpayments,
  //       OnBoarding:decodedObject.datas.Compliance.OnBoarding,
  //       Secretarial:decodedObject.datas.Compliance.Secretarial
  //     })
  //     setpeoples({
  //       ...peolples,
  //       peolplesexample:decodedObject.datas.peolples.peolplesexample,
  //       PeopleStability:decodedObject.datas.peolples.PeopleStability,
  //       GoalSheets:decodedObject.datas.peolples.GoalSheets

  //     });
  //     setFinance({
  //       ...Finance,
  //       Financelist: decodedObject.datas.Finance.Financelist,
  //       ImplementationofaFinance: decodedObject.datas.Finance.ImplementationofaFinance,
  //       Achievean: decodedObject.datas.Finance.Achievean,
  //       ensureTotal: decodedObject.datas.Finance.ensureTotal,
  //       EnsureTax: decodedObject.datas.Finance.EnsureTax,
  //       TreasuryIncome :decodedObject.datas.Finance.TreasuryIncome ,


  //     });
  //     setProjectsInitiatives({
  //       ...ProjectsInitiatives ,
  //       ProjectsInitiativesdata: decodedObject.datas.ProjectsInitiatives.ProjectsInitiativesdata,
  //       Implementationdatas:    decodedObject.datas.ProjectsInitiatives.Implementationdatas,
  //       Hiringand:  decodedObject.datas.ProjectsInitiatives.Hiringand,
  //       ImplementationofVariable :decodedObject.datas.ProjectsInitiatives.ImplementationofVariable,
  //       StatutoryAudit:  decodedObject.datas.ProjectsInitiatives.StatutoryAudit,

  //     })
  //     setCustomer({
  //       ...Customer ,
  //       Customerlist: decodedObject.datas.Customer.Customerlist,
  //       CustomerConnect:    decodedObject.datas.Customer.CustomerConnect,
  //       CustomerSatisfaction:  decodedObject.datas.Customer.CustomerSatisfaction,
  //       CustomerAccounts :decodedObject.datas.Customer.CustomerAccounts,
  //       CustomerDashboards:  decodedObject.datas.Customer.CustomerDashboards,
  //     })   
  //       }
  //   }
  // }, [state.AppraisalDatasListesUDS.AppraisalDataListes , setEditIds]);

  useEffect(() => {
  if (editIds != ""  ) {
      if(editIds == state.AppraisalSliceDatasss.AppraisalDatasLists?.id &&
    state.AppraisalSliceDatasss.AppraisalDatasLists){ 
    const performHtml = state.AppraisalSliceDatasss.AppraisalDatasLists.perform_html;

    if (performHtml) {
      const decodedObject = JSON.parse(performHtml);

      setBusiness(prev => ({
        ...prev,
        ...decodedObject.datas.Business
      }));

      setOperational(prev => ({
        ...prev,
        ...decodedObject.datas.Operational
      }));

      setCompliance(prev => ({
        ...prev,
        ...decodedObject.datas.Compliance
      }));

      setpeoples(prev => ({
        ...prev,
        ...decodedObject.datas.peolples
      }));

      setFinance(prev => ({
        ...prev,
        ...decodedObject.datas.Finance
      }));

      setProjectsInitiatives(prev => ({
        ...prev,
        ...decodedObject.datas.ProjectsInitiatives
      }));

      setCustomer(prev => ({
        ...prev,
        ...decodedObject.datas.Customer
      }));
    }
  }
  }
}, [state.AppraisalSliceDatasss.AppraisalDatasLists, editIds]);


  const HandleSubmit = (e) => {
    const html = document.getElementById("perfomanceAppriasal").innerHTML;

    if (editIds == "" ) {
      const datas = {
        Business: Business,
        Operational: Operational,
        Compliance: Compliance,
        peolples: peolples,
        ProjectsInitiatives: ProjectsInitiatives,
        Finance: Finance,
        Customer: Customer,
      };
      const payload = {
        user_id: state.ClientBranchIDs.userProfileId, ///user id
        /// perform_html: html,
        perform_html: JSON.stringify({ datas }),
      };
      dispatch(setAppraisalHtmlPostActions(payload, setshow(true)));
    } else if (editIds != "") {
      const datas = {
        Business: Business,
        Operational: Operational,
        Compliance: Compliance,
        peolples: peolples,
        ProjectsInitiatives: ProjectsInitiatives,
        Finance: Finance,
        Customer: Customer,
      };
      const payload = {
        // EditId: state.AppraisalPostcall.AppraisalPostData,
        EditId:editIds,
        innerdata: {
          //   perform_html: html,
          perform_html: JSON.stringify({ datas }),
          user_id: state.ClientBranchIDs.userProfileId, ///user id
        },
      };
      console.log(payload ,"poaisAOI Spayload");
      
      dispatch(setThePerformsAgentEditACtion(payload, setshow(true)));
    }
        // setshow(true)

  };

  const test1 = [
    {
      id: 1,
      testing: "1",
    },
    {
      id: 2,
      testing: " Period    ",
    },

    {
      id: 3,
      testing: "1st April 2022 to 31st March 2023.",
    },
  ];

  const threeMap = [
    {
      id: 1,
      testing: "Metric/ Measurement",
    },
    {
      id: 2,
      testing: "Weightage (Illustration)  ",
    },

    {
      id: 3,
      testing: "Target (Will vary for each person)",
    },
  ];

  const Achievement = [
    {
      id: 1,
      testing: "% Achievement",
    },
    {
      id: 2,
      testing: "Weighted Avg Score",
    },

    {
      id: 3,
      testing: "Explanatory / Qualifying Remarks",
    },
  ];

  const AchievementAns = [
    {
      id: 1,
      testing: "(d) = (c)/(b) x 100",
    },
    {
      id: 2,
      testing: "(d) x (a)",
    },

    {
      id: 3,
      testing: "",
    },
  ];

  const number = [
    {
      id: 1,
      name: "Sl Number",
    },
    {
      id: 2,
      name: "Goal (Some examples)",
    },
  ];

  const number1 = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "Business and Financial Goals",
    },
  ];

  const number3 = [
    {
      id: 1,
      name: "1",
    },
    {
      id: 2,
      name: "Revenue",
    },
  ];

  const number4 = [
    {
      id: 1,
      name: "2",
    },
    {
      id: 2,
      name: "EBITDA",
    },
  ];

  const number5 = [
    {
      id: 1,
      name: "3",
    },
    {
      id: 2,
      name: "New Business (Existing Customers)",
    },
  ];
  const number6 = [
    {
      id: 1,
      name: "4",
    },
    {
      id: 2,
      name: "New Business (New Logos)",
    },
  ];

  const number7 = [
    {
      id: 1,
      name: "5",
    },
    {
      id: 2,
      name: "Collections",
    },
  ];

  const number8 = [
    {
      id: 1,
      name: "6",
    },
    {
      id: 2,
      name: "Customer Retention",
    },
  ];

  const number9 = [
    {
      id: 1,
      name: "7",
    },
    {
      id: 2,
      name: "Revenue / Profit Leakage",
    },
  ];

  const number10 = [
    {
      id: 1,
      name: "8",
    },
    {
      id: 2,
      name: "Technology Deployment",
    },
  ];

  const Area2 = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "Operational Metrics",
    },
  ];

  const Areacontent2 = [
    {
      id: 1,
      name: "1",
    },
    {
      id: 2,
      name: "Timely Attendance",
    },
  ];

  const Areacontent022 = [
    {
      id: 1,
      name: "2",
    },
    {
      id: 2,
      name: "Timely Payroll",
    },
  ];

  const Areacontent032 = [
    {
      id: 1,
      name: "3",
    },
    {
      id: 2,
      name: "Timely inoicing",
    },
  ];

  const Areacontent042 = [
    {
      id: 1,
      name: "4",
    },
    {
      id: 2,
      name: "Fill Rates",
    },
  ];

  const Area3 = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "Compliance",
    },
  ];

  const areaCompliance1 = [
    {
      id: 1,
      name: "1",
    },
    {
      id: 1,
      name: "Timely PF and ESI payments ",
    },
  ];

  const areaCompliance2 = [
    {
      id: 1,
      name: "2",
    },
    {
      id: 2,
      name: "On-Boarding Process Incl. KYC",
    },
  ];

  const areaCompliance3 = [
    {
      id: 1,
      name: "3",
    },
    {
      id: 3,
      name: "Timely Statutory Secretarial filings and procedural Adherence",
    },
  ];

  const Area4 = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "People (Examples)",
    },
  ];

  const Peoplelist = [
    {
      id: 1,
      name: "1",
    },

    {
      id: 1,
      name: "People Stability – No attrition with 1 year of hiring",
    },
  ];

  const Peoplelist1 = [
    {
      id: 1,
      name: "2",
    },
    {
      id: 2,
      name: "Goal Sheets for 100% of Employees",
    },
  ];

  const Area5 = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "Projects / Initiatives (Examples from across Areas/Functions)",
    },
  ];
  const Area5content = [
    {
      id: 1,
      name: "1",
    },
    {
      id: 2,
      name: "Implementation of the Funnel Mgmt System for BD",
    },
  ];

  const Area5content01 = [
    {
      id: 1,
      name: "2",
    },
    {
      id: 2,
      name: "Hiring and Deployment of the BD Team",
    },
  ];

  const Area5content02 = [
    {
      id: 1,
      name: "3",
    },
    {
      id: 2,
      name: "Implementation of Variable Pay",
    },
  ];

  const Area5content03 = [
    {
      id: 1,
      name: "4",
    },
    {
      id: 2,
      name: "Statutory Audit Completion for FY 22",
    },
  ];

  const Area6 = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "Finance (Examples)",
    },
  ];
  const Area6conten1 = [
    {
      id: 1,
      name: "1",
    },
    {
      id: 2,
      name: "Implementation of a Finance Structure aligned with Business Goals for the Year",
    },
  ];

  const Area6conten2 = [
    {
      id: 1,
      name: "2",
    },
    {
      id: 2,
      name: "To Achieve an Effective Tax Rate of XX%",
    },
  ];

  const Area6conten3 = [
    {
      id: 1,
      name: "3",
    },
    {
      id: 2,
      name: "To ensure Total Indirect Cost savings are achieved over Budget",
    },
  ];
  const Area6conten4 = [
    {
      id: 1,
      name: "4",
    },
    {
      id: 2,
      name: "Ensure Tax and Treasury integration as planned within Group Companies",
    },
  ];
  const Area6conten5 = [
    {
      id: 1,
      name: "5",
    },
    {
      id: 2,
      name: "Treasury Income during FY 23",
    },
  ];

  const Area7 = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "Customer",
    },
  ];

  const Area7content1 = [
    {
      id: 1,
      name: "1",
    },
    {
      id: 2,
      name: "Customer Connect",
    },
  ];
  const Area7content2 = [
    {
      id: 1,
      name: "2",
    },
    {
      id: 2,
      name: "Customer Satisfaction",
    },
  ];

  const Area7content3 = [
    {
      id: 1,
      name: "3",
    },
    {
      id: 2,
      name: "Customer Accounts",
    },
  ];

  const Area7content4 = [
    {
      id: 1,
      name: "4",
    },
    {
      id: 2,
      name: "Customer Dashboards",
    },
  ];
  ///--Hanlde---changes as text ---fields
  const [Business, setBusiness] = useState({
    BusinessHeader: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },

    Revenue: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },

    EBITDA: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    NewBusiness: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    NewLogos: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    Collections: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    CustomerRetention: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    RevenueProfitLeakage: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    TechnologyDeployment: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
  });

  /// changes---
  const HandleBussinessChanges = (e, values) => {
    if (values == "BusinessHeader") {
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        BusinessHeader: {
          ...prevState.BusinessHeader,
          [name]: value,
        },
      }));
    } else if (values == "Revenue") {
      console.log(values, "Revenue");
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        Revenue: {
          ...prevState.Revenue,
          [name]: value,
        },
      }));
    } else if (values == "EBITDA") {
      console.log(values, "EBITDA");
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        EBITDA: {
          ...prevState.EBITDA,
          [name]: value,
        },
      }));
    } else if (values == "NewBusiness") {
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        NewBusiness: {
          ...prevState.NewBusiness,
          [name]: value,
        },
      }));
    } else if (values == "NewLogos") {
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        NewLogos: {
          ...prevState.NewLogos,
          [name]: value,
        },
      }));
    } else if (values == "Collections") {
      console.log(values, "EBITDA");
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        Collections: {
          ...prevState.Collections,
          [name]: value,
        },
      }));
    } else if (values == "CustomerRetention") {
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        CustomerRetention: {
          ...prevState.CustomerRetention,
          [name]: value,
        },
      }));
    } else if (values == "RevenueProfitLeakage") {
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        RevenueProfitLeakage: {
          ...prevState.RevenueProfitLeakage,
          [name]: value,
        },
      }));
    } else if (values == "TechnologyDeployment") {
      const { name, value } = e.target;
      setBusiness((prevState) => ({
        ...prevState,
        TechnologyDeployment: {
          ...prevState.TechnologyDeployment,
          [name]: value,
        },
      }));
    }
  };

  const [Operational, setOperational] = useState({
    OperationalMetrics: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    TimelyAttendance: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    TimelyPayroll: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    Timelyinoicing: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    FillRates: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
  });

  ///changes ---
  const HandleOperationListsed = (e, values) => {
    if (values == "OperationalMetrics") {
      const { name, value } = e.target;
      setOperational((prevState) => ({
        ...prevState,
        OperationalMetrics: {
          ...prevState.OperationalMetrics,
          [name]: value,
        },
      }));
    } else if (values == "TimelyAttendance") {
      const { name, value } = e.target;
      setOperational((prevState) => ({
        ...prevState,
        TimelyAttendance: {
          ...prevState.TimelyAttendance,
          [name]: value,
        },
      }));
    } else if (values == "TimelyPayroll") {
      const { name, value } = e.target;
      setOperational((prevState) => ({
        ...prevState,
        TimelyPayroll: {
          ...prevState.TimelyPayroll,
          [name]: value,
        },
      }));
    } else if (values == "Timelyinoicing") {
      const { name, value } = e.target;
      setOperational((prevState) => ({
        ...prevState,
        Timelyinoicing: {
          ...prevState.Timelyinoicing,
          [name]: value,
        },
      }));
    } else if (values == "FillRates") {
      const { name, value } = e.target;
      setOperational((prevState) => ({
        ...prevState,
        FillRates: {
          ...prevState.FillRates,
          [name]: value,
        },
      }));
    }
  };

  const [Compliance, setCompliance] = useState({
    Compliancedatas: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    ESIpayments: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    OnBoarding: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    Secretarial: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
  });

  const HandleComplianceListsed = (e, values) => {
    if (values == "Compliance") {
      const { name, value } = e.target;
      setCompliance((prevState) => ({
        ...prevState,
        Compliancedatas: {
          ...prevState.Compliancedatas,
          [name]: value,
        },
      }));
    } else if (values == "ESIpayments") {
      const { name, value } = e.target;
      setCompliance((prevState) => ({
        ...prevState,
        ESIpayments: {
          ...prevState.ESIpayments,
          [name]: value,
        },
      }));
    } else if (values == "OnBoarding") {
      const { name, value } = e.target;
      setCompliance((prevState) => ({
        ...prevState,
        OnBoarding: {
          ...prevState.OnBoarding,
          [name]: value,
        },
      }));
    } else if (values == "Secretarial") {
      const { name, value } = e.target;
      setCompliance((prevState) => ({
        ...prevState,
        Secretarial: {
          ...prevState.Secretarial,
          [name]: value,
        },
      }));
    }
  };
  const [peolples, setpeoples] = useState({
    peolplesexample: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    PeopleStability: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    GoalSheets: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
  });

  const HandlePeopleListsed = (e, values) => {
    if (values == "peolplesexample") {
      const { name, value } = e.target;
      setpeoples((prevState) => ({
        ...prevState,
        peolplesexample: {
          ...prevState.peolplesexample,
          [name]: value,
        },
      }));
    } else if (values == "PeopleStability") {
      const { name, value } = e.target;
      setpeoples((prevState) => ({
        ...prevState,
        PeopleStability: {
          ...prevState.PeopleStability,
          [name]: value,
        },
      }));
    } else if (values == "GoalSheets") {
      const { name, value } = e.target;
      setpeoples((prevState) => ({
        ...prevState,
        GoalSheets: {
          ...prevState.GoalSheets,
          [name]: value,
        },
      }));
    }
  };

  const [ProjectsInitiatives, setProjectsInitiatives] = useState({
    ProjectsInitiativesdata: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    Implementationdatas: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    Hiringand: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },

    ImplementationofVariable: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },

    StatutoryAudit: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
  });

  ///changes--
  const HandleProjectsInitiativesListsed = (e, values) => {
    console.log(values, "values", e.target.va);
    if (values == "ProjectsInitiativesdata") {
      const { name, value } = e.target;
      setProjectsInitiatives((prevState) => ({
        ...prevState,
        ProjectsInitiativesdata: {
          ...prevState.ProjectsInitiativesdata,
          [name]: value,
        },
      }));
    } else if (values == "Implementationdatas") {
      const { name, value } = e.target;
      console.log(e.target, "e.target");
      setProjectsInitiatives((prevState) => ({
        ...prevState,
        Implementationdatas: {
          ...prevState.Implementationdatas,
          [name]: value,
        },
      }));
    } else if (values == "Hiringand") {
      const { name, value } = e.target;
      setProjectsInitiatives((prevState) => ({
        ...prevState,
        Hiringand: {
          ...prevState.Hiringand,
          [name]: value,
        },
      }));
    } else if (values == "ImplementationofVariable") {
      const { name, value } = e.target;
      setProjectsInitiatives((prevState) => ({
        ...prevState,
        ImplementationofVariable: {
          ...prevState.ImplementationofVariable,
          [name]: value,
        },
      }));
    } else if (values == "StatutoryAudit") {
      const { name, value } = e.target;
      setProjectsInitiatives((prevState) => ({
        ...prevState,
        StatutoryAudit: {
          ...prevState.StatutoryAudit,
          [name]: value,
        },
      }));
    }
  };

  console.log(ProjectsInitiatives , "ProjectsInitiatives");

  const [Finance, setFinance] = useState({
    Financelist: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    ImplementationofaFinance: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },

    Achievean: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    ensureTotal: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },

    EnsureTax: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    TreasuryIncome: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
  });
  const HandleFinancelistsListsed = (e, values) => {
    if (values == "FinanceInitialState") {
      const { name, value } = e.target;
      setFinance((prevState) => ({
        ...prevState,
        Financelist: {
          ...prevState.Financelist,
          [name]: value,
        },
      }));
    } else if (values == "ImplementationofaFinance") {
      const { name, value } = e.target;
      setFinance((prevState) => ({
        ...prevState,
        ImplementationofaFinance: {
          ...prevState.ImplementationofaFinance,
          [name]: value,
        },
      }));
    } else if (values == "Achievean") {
      const { name, value } = e.target;
      setFinance((prevState) => ({
        ...prevState,
        Achievean: {
          ...prevState.Achievean,
          [name]: value,
        },
      }));
    } else if (values == "ensureTotal") {
      const { name, value } = e.target;
      setFinance((prevState) => ({
        ...prevState,
        ensureTotal: {
          ...prevState.ensureTotal,
          [name]: value,
        },
      }));
    } else if (values == "EnsureTax") {
      const { name, value } = e.target;
      setFinance((prevState) => ({
        ...prevState,
        EnsureTax: {
          ...prevState.EnsureTax,
          [name]: value,
        },
      }));
    } else if (values == "TreasuryIncome") {
      const { name, value } = e.target;
      setFinance((prevState) => ({
        ...prevState,
        TreasuryIncome: {
          ...prevState.TreasuryIncome,
          [name]: value,
        },
      }));
    }
  };
  const [Customer, setCustomer] = useState({
    Customerlist: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    CustomerConnect: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    CustomerSatisfaction: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },

    CustomerAccounts: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
    CustomerDashboards: {
      firstOne: "",
      secondOne: "",
      thirdOne: "",
      fourOne: "",
      fiveth: "",
      sixOne: "",
      seventh: "",
    },
  });
  const HandleCustomerListsed = (e, values) => {
    if (values == "Customerlist") {
      const { name, value } = e.target;
      setCustomer((prevState) => ({
        ...prevState,
        Customerlist: {
          ...prevState.Customerlist,
          [name]: value,
        },
      }));
    } else if (values == "CustomerConnect") {
      const { name, value } = e.target;
      setCustomer((prevState) => ({
        ...prevState,
        CustomerConnect: {
          ...prevState.CustomerConnect,
          [name]: value,
        },
      }));
    } else if (values == "CustomerSatisfaction") {
      const { name, value } = e.target;
      setCustomer((prevState) => ({
        ...prevState,
        CustomerSatisfaction: {
          ...prevState.CustomerSatisfaction,
          [name]: value,
        },
      }));
    } else if (values == "CustomerAccounts") {
      const { name, value } = e.target;
      setCustomer((prevState) => ({
        ...prevState,
        CustomerAccounts: {
          ...prevState.CustomerAccounts,
          [name]: value,
        },
      }));
    } else if (values == "CustomerDashboards") {
      const { name, value } = e.target;
      setCustomer((prevState) => ({
        ...prevState,
        CustomerDashboards: {
          ...prevState.CustomerDashboards,
          [name]: value,
        },
      }));
    }
  };
   console.log(Operational.TimelyAttendance , "Operational");
  return (
    <>
      {/* -------------------Excel-----sheet-------------------------------- */}

      <div
        id="perfomanceAppriasal"
        //ref={componentRef}
        // style={{ padding: "30px", background: "white"  }}
        ref={ref}
      >
        <div
          className="innerApparisalperform"
          //  style={{ border: "1px solid #000",padding: "65px",
          // paddingLeft:"0px !important", paddingRight:"0px !important" ,  background: "white"   }}
        >
          {/* -----Firts---------------------- */}
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    gap: "10px",
                    background: "white",
                  }}
                >
                  <div>
                    <div style={{ width: "90px" }}>
                      <img
                        src={UDSprofile}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "justify",
                      fontSize: "25px",
                    }}
                  >
                    GOAL SETTING FOR THE YEAR {pastYear}-{currentYear}
                  </div>
                </td>
                {/* <td
                  style={{	
                    textAlign: "justify",
                    fontSize: "20px",
                  }}
                >
                  GOAL SETTING FOR THE YEAR 2022-23
                </td> */}
              </tr>
            </tbody>
          </table>

          {/* -----second---------------------- */}
          <table className="AppraisalTables" style={{ width: "100%" }}>
            <tbody>
              <tr style={{ width: "100%" }}>
                <td
                  style={{
                    //    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    paddingLeft:"23px"
                  }}
                  colSpan={2}
                >
                  Name of the Employee
                  <br />
                </td>

                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
           border: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            Cell {index + 1}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    paddingLeft:"27px"
                  }}
                >
                  Employee Number/Location
                  <br />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
           border: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            Cell {index + 1}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>
              {/* ------Second--------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(1)].map((_, index) => (
                          <>
                              <td
                                key={index}
                                style={{
                                  fontSize: "20px",
                                  height: "86px",
                                  fontSize: "20px",
                                  paddingLeft:"12px"
                                }}
                              >
                                Designation
                              </td>
                          
                          </>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody style={{ height: "85px" }}>
                      <tr>
                        {[...Array(test1.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              borderBottom: "none",
                              fontSize: "20px",
                              width: "130px",
                            }}
                          >
                            <>
                              {index == 2 ? (
                                <textarea
                                  style={{
                                    width: "100%",
                                    height: "85px",
                                  }}
                                />
                              ) : null}
                            </>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    width: "3.7451%",
                    paddingLeft:"23px"
                  }}
                >
                  Division/Region/Department
                  <br />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                   
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
           border: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                  
                            Cell {index + 1}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>
              {/* ------------------------Third------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              width: index != 0 ? "50%" : "27%",
                              height: "187px",
                            }}
                          >
                            <>{number[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody style={{ height: "182px" }}>
                      <tr>
                        {[...Array(threeMap.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight: "0.2px solid #000",
                              borderLeft: "0.2px solid #000",
                              fontSize: "20px",
                              width: index != 2 ? "33%" : "auto",
                            }}
                          >
                            {threeMap[index].testing}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    width: "3.7451%",
                    textAlign:"center"
                  }}
                >
                  Achievement
                  <br />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Achievement.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 2 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "187px",
                              width:index == 0 ? "132px": index == 1 ?"131px":""
                            }}
                          >
                            {Achievement[index].testing}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ------------------------Four------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                              width: index != 0 ? "82%" : "7%",
                            }}
                          >
                            <span style={{ paddingLeft:index == 0 ? "97px":"" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                              width: index != 2 ? "33%" : "auto",
                            }}
                          >
                            {" "}
                            <span style={{ padding: "60px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    width: "3.7451%",
                    textAlign:"center"
                  }}
                >
                  (c)
                  <br />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            <input style={{ width: "100%", height: "100%",}} />
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ------------------------five------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody tbody style={{ height: "146px" }}>
                      <tr>
                        {[...Array(number1.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "86px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: "center",
                            }}
                          >
                            <>{number1[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              width: index != 0 ? "auto" : "33%",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleBussinessChanges(e, "BusinessHeader");
                                }}
                                value={
                                  Business.BusinessHeader.firstOne !=
                                    undefined &&
                                  Business.BusinessHeader.firstOne != null
                                    ? Business.BusinessHeader.firstOne
                                    : ""
                                }
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleBussinessChanges(
                                        e,
                                        "BusinessHeader"
                                      );
                                    }}
                                    value={Business.BusinessHeader.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleBussinessChanges(
                                        e,
                                        "BusinessHeader"
                                      );
                                    }}
                                    value={Business.BusinessHeader.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px", }}
                    name="fourOne"
                    type="text"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "BusinessHeader");
                    }}
                    value={Business.BusinessHeader.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleBussinessChanges(e, "BusinessHeader");
                                }}
                                value={Business.BusinessHeader.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleBussinessChanges(
                                        e,
                                        "BusinessHeader"
                                      );
                                    }}
                                    value={Business.BusinessHeader.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleBussinessChanges(
                                        e,
                                        "BusinessHeader"
                                      );
                                    }}
                                    value={Business.BusinessHeader.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ---  Business Revenue---------------------Six------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number3.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{number3[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",

                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "Revenue");
                                  }}
                                  value={Business.Revenue.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "Revenue");
                                      }}
                                      value={Business.Revenue.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "Revenue");
                                      }}
                                      value={Business.Revenue.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "Revenue");
                    }}
                    value={Business.Revenue.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "Revenue");
                                  }}
                                  value={Business.Revenue.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "Revenue");
                                      }}
                                      value={Business.Revenue.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "Revenue");
                                      }}
                                      value={Business.Revenue.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ------------------------seven------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number4.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{number4[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "EBITDA");
                                  }}
                                  value={Business.EBITDA.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "EBITDA");
                                      }}
                                      value={Business.EBITDA.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "EBITDA");
                                      }}
                                      value={Business.EBITDA.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "EBITDA");
                    }}
                    value={Business.EBITDA.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "EBITDA");
                                  }}
                                  value={Business.EBITDA.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "EBITDA");
                                      }}
                                      value={Business.EBITDA.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "EBITDA");
                                      }}
                                      value={Business.EBITDA.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ------------------------Eight------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number5.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{number5[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "NewBusiness");
                                  }}
                                  value={Business.NewBusiness.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "NewBusiness"
                                        );
                                      }}
                                      value={Business.NewBusiness.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "NewBusiness"
                                        );
                                      }}
                                      value={Business.NewBusiness.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "NewBusiness");
                    }}
                    value={Business.NewBusiness.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "NewBusiness");
                                  }}
                                  value={Business.NewBusiness.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "NewBusiness"
                                        );
                                      }}
                                      value={Business.NewBusiness.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "NewBusiness"
                                        );
                                      }}
                                      value={Business.NewBusiness.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ------------------------nine------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number6.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{number6[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "NewLogos");
                                  }}
                                  value={Business.NewLogos.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "NewLogos");
                                      }}
                                      value={Business.NewLogos.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "NewLogos");
                                      }}
                                      value={Business.NewLogos.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "NewLogos");
                    }}
                    value={Business.NewLogos.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "NewLogos");
                                  }}
                                  value={Business.NewLogos.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "NewLogos");
                                      }}
                                      value={Business.NewLogos.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(e, "NewLogos");
                                      }}
                                      value={Business.NewLogos.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* -----------------------ten------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number7.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{number7[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "Collections");
                                  }}
                                  value={Business.Collections.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "Collections"
                                        );
                                      }}
                                      value={Business.Collections.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "Collections"
                                        );
                                      }}
                                      value={Business.Collections.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px", }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "Collections");
                    }}
                    value={Business.Collections.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(e, "Collections");
                                  }}
                                  value={Business.Collections.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "Collections"
                                        );
                                      }}
                                      value={Business.Collections.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "Collections"
                                        );
                                      }}
                                      value={Business.Collections.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* -----------------------ten------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number8.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{number8[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(
                                      e,
                                      "CustomerRetention"
                                    );
                                  }}
                                  value={Business.CustomerRetention.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "CustomerRetention"
                                        );
                                      }}
                                      value={
                                        Business.CustomerRetention.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "CustomerRetention"
                                        );
                                      }}
                                      value={
                                        Business.CustomerRetention.thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px", }}
                    type="text "
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "CustomerRetention");
                    }}
                    value={Business.CustomerRetention.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(
                                      e,
                                      "CustomerRetention"
                                    );
                                  }}
                                  value={Business.CustomerRetention.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "CustomerRetention"
                                        );
                                      }}
                                      value={Business.CustomerRetention.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "CustomerRetention"
                                        );
                                      }}
                                      value={Business.CustomerRetention.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* -----------------------elevean------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number9.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              textAlign: index != 0 ? "center" : "right",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <>{number9[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(
                                      e,
                                      "RevenueProfitLeakage"
                                    );
                                  }}
                                  value={Business.RevenueProfitLeakage.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "RevenueProfitLeakage"
                                        );
                                      }}
                                      value={
                                        Business.RevenueProfitLeakage.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "RevenueProfitLeakage"
                                        );
                                      }}
                                      value={
                                        Business.RevenueProfitLeakage.thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px", }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "RevenueProfitLeakage");
                    }}
                    value={Business.RevenueProfitLeakage.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(
                                      e,
                                      "RevenueProfitLeakage"
                                    );
                                  }}
                                  value={Business.RevenueProfitLeakage.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "RevenueProfitLeakage"
                                        );
                                      }}
                                      value={
                                        Business.RevenueProfitLeakage.sixOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "RevenueProfitLeakage"
                                        );
                                      }}
                                      value={
                                        Business.RevenueProfitLeakage.seventh
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* -----------------------twe------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{number10[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleBussinessChanges(
                                      e,
                                      "TechnologyDeployment"
                                    );
                                  }}
                                  value={Business.TechnologyDeployment.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "TechnologyDeployment"
                                        );
                                      }}
                                      value={
                                        Business.TechnologyDeployment.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "TechnologyDeployment"
                                        );
                                      }}
                                      value={
                                        Business.TechnologyDeployment.thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleBussinessChanges(e, "TechnologyDeployment");
                    }}
                    value={Business.TechnologyDeployment.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleBussinessChanges(
                                      e,
                                      "TechnologyDeployment"
                                    );
                                  }}
                                  value={Business.TechnologyDeployment.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "TechnologyDeployment"
                                        );
                                      }}
                                      value={
                                        Business.TechnologyDeployment.sixOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleBussinessChanges(
                                          e,
                                          "TechnologyDeployment"
                                        );
                                      }}
                                      value={
                                        Business.TechnologyDeployment.seventh
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* -----------------------Last  Empty datas------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>
              {/* ---  Business Revenue---------------------End------------------------------- */}
              {/* -------------------Operations-----------Metircs----------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody tbody style={{ height: "146px" }}>
                      <tr>
                        {[...Array(Area2.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "86px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: "center",
                            }}
                          >
                            <>{Area2[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              width: index != 0 ? "auto" : "33%",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleOperationListsed(
                                    e,
                                    "OperationalMetrics"
                                  );
                                }}
                                value={Operational.OperationalMetrics.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleOperationListsed(
                                        e,
                                        "OperationalMetrics"
                                      );
                                    }}
                                    value={
                                      Operational.OperationalMetrics.secondOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleOperationListsed(
                                        e,
                                        "OperationalMetrics"
                                      );
                                    }}
                                    value={
                                      Operational.OperationalMetrics.thirdOne
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    name="fourOne"
                    type="text"
                    onChange={(e) => {
                      HandleOperationListsed(e, "OperationalMetrics");
                    }}
                    value={Operational.OperationalMetrics.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleOperationListsed(
                                    e,
                                    "OperationalMetrics"
                                  );
                                }}
                                value={Operational.OperationalMetrics.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleOperationListsed(
                                        e,
                                        "OperationalMetrics"
                                      );
                                    }}
                                    value={
                                      Operational.OperationalMetrics.sixOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleOperationListsed(
                                        e,
                                        "OperationalMetrics"
                                      );
                                    }}
                                    value={
                                      Operational.OperationalMetrics.seventh
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ---------------Inner----------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Areacontent2.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              textAlign: index != 0 ? "center" : "right",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <>{Areacontent2[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleOperationListsed(
                                      e,
                                      "TimelyAttendance"
                                    );
                                  }}
                                  value={Operational.TimelyAttendance.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyAttendance"
                                        );
                                      }}
                                      value={
                                        Operational.TimelyAttendance.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyAttendance"
                                        );
                                      }}
                                      value={
                                        Operational.TimelyAttendance.thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px", }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleOperationListsed(e, "TimelyAttendance");
                    }}
                    value={Operational.TimelyAttendance.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleOperationListsed(
                                      e,
                                      "TimelyAttendance"
                                    );
                                  }}
                                  value={Operational.TimelyAttendance.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyAttendance"
                                        );
                                      }}
                                      value={
                                        Operational.TimelyAttendance.sixOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyAttendance"
                                        );
                                      }}
                                      value={
                                        Operational.TimelyAttendance.seventh
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Areacontent022.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              textAlign: index != 0 ? "center" : "right",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <>{Areacontent022[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleOperationListsed(e, "TimelyPayroll");
                                  }}
                                  value={Operational.TimelyPayroll.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyPayroll"
                                        );
                                      }}
                                      value={
                                        Operational.TimelyPayroll.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyPayroll"
                                        );
                                      }}
                                      value={Operational.TimelyPayroll.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleOperationListsed(e, "TimelyPayroll");
                    }}
                    value={Operational.TimelyPayroll.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleOperationListsed(e, "TimelyPayroll");
                                  }}
                                  value={Operational.TimelyPayroll.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyPayroll"
                                        );
                                      }}
                                      value={Operational.TimelyPayroll.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "TimelyPayroll"
                                        );
                                      }}
                                      value={Operational.TimelyPayroll.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Areacontent032.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              textAlign: index != 0 ? "center" : "right",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <>{Areacontent032[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleOperationListsed(e, "Timelyinoicing");
                                  }}
                                  value={Operational.Timelyinoicing.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "Timelyinoicing"
                                        );
                                      }}
                                      value={
                                        Operational.Timelyinoicing.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "Timelyinoicing"
                                        );
                                      }}
                                      value={
                                        Operational.Timelyinoicing.thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleOperationListsed(e, "Timelyinoicing");
                    }}
                    value={Operational.Timelyinoicing.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleOperationListsed(e, "Timelyinoicing");
                                  }}
                                  value={Operational.Timelyinoicing.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "Timelyinoicing"
                                        );
                                      }}
                                      value={Operational.Timelyinoicing.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleOperationListsed(
                                          e,
                                          "Timelyinoicing"
                                        );
                                      }}
                                      value={Operational.Timelyinoicing.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Areacontent042.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              textAlign: index != 0 ? "center" : "right",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <>{Areacontent042[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleOperationListsed(e, "FillRates");
                                  }}
                                  value={Operational.FillRates.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(e, "FillRates");
                                      }}
                                      value={Operational.FillRates.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(e, "FillRates");
                                      }}
                                      value={Operational.FillRates.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleOperationListsed(e, "FillRates");
                    }}
                    value={Operational.FillRates.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleOperationListsed(e, "FillRates");
                                  }}
                                  value={Operational.FillRates.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleOperationListsed(e, "FillRates");
                                      }}
                                      value={Operational.FillRates.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleOperationListsed(e, "FillRates");
                                      }}
                                      value={Operational.FillRates.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* -------------------End-of metricx----------------- */}
              {/* -----------------------Last  Empty datas------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>
              {/* -------------------Compliance---------------------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody tbody style={{ height: "146px" }}>
                      <tr>
                        {[...Array(Area3.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "86px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: "center",
                            }}
                          >
                            <>{Area3[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              width: index != 0 ? "auto" : "33%",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleComplianceListsed(e, "Compliance");
                                }}
                                value={Compliance.Compliancedatas.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleComplianceListsed(e, "Compliance");
                                    }}
                                    value={Compliance.Compliancedatas.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleComplianceListsed(e, "Compliance");
                                    }}
                                    value={Compliance.Compliancedatas.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px", }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleComplianceListsed(e, "Compliance");
                    }}
                    value={Compliance.Compliancedatas.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleComplianceListsed(e, "Compliance");
                                }}
                                value={Compliance.Compliancedatas.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleComplianceListsed(e, "Compliance");
                                    }}
                                    value={Compliance.Compliancedatas.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleComplianceListsed(e, "Compliance");
                                    }}
                                    value={Compliance.Compliancedatas.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ----------------------Inner Compoliances------------------------ */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(areaCompliance1.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{areaCompliance1[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleComplianceListsed(e, "ESIpayments");
                                  }}
                                  value={Compliance.ESIpayments.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "ESIpayments"
                                        );
                                      }}
                                      value={Compliance.ESIpayments.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "ESIpayments"
                                        );
                                      }}
                                      value={Compliance.ESIpayments.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleComplianceListsed(e, "ESIpayments");
                    }}
                    value={Compliance.ESIpayments.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleComplianceListsed(e, "ESIpayments");
                                  }}
                                  value={Compliance.ESIpayments.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "ESIpayments"
                                        );
                                      }}
                                      value={Compliance.ESIpayments.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "ESIpayments"
                                        );
                                      }}
                                      value={Compliance.ESIpayments.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(areaCompliance2.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{areaCompliance2[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleComplianceListsed(e, "OnBoarding");
                                  }}
                                  value={Compliance.OnBoarding.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "OnBoarding"
                                        );
                                      }}
                                      value={Compliance.OnBoarding.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "OnBoarding"
                                        );
                                      }}
                                      value={Compliance.OnBoarding.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleComplianceListsed(e, "OnBoarding");
                    }}
                    value={Compliance.OnBoarding.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "149px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleComplianceListsed(e, "OnBoarding");
                                  }}
                                  value={Compliance.OnBoarding.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "OnBoarding"
                                        );
                                      }}
                                      value={Compliance.OnBoarding.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "149px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "OnBoarding"
                                        );
                                      }}
                                      value={Compliance.OnBoarding.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(areaCompliance3.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "228px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{areaCompliance3[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "228px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleComplianceListsed(e, "Secretarial");
                                  }}
                                  value={Compliance.Secretarial.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "228px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "Secretarial"
                                        );
                                      }}
                                      value={Compliance.Secretarial.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "228px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "Secretarial"
                                        );
                                      }}
                                      value={Compliance.Secretarial.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "230px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleComplianceListsed(e, "Secretarial");
                    }}
                    value={Compliance.Secretarial.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "228px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleComplianceListsed(e, "Secretarial");
                                  }}
                                  value={Compliance.Secretarial.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "228px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "Secretarial"
                                        );
                                      }}
                                      value={Compliance.Secretarial.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "228px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleComplianceListsed(
                                          e,
                                          "Secretarial"
                                        );
                                      }}
                                      value={Compliance.Secretarial.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ------------------Compliance------End--------------------- */}
              {/* -----------------------Last  Empty datas------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>

              {/* -------------------People (Examples)---------------------------------------------- */}
              <tr
                style={{
                  // pageBreakBefore: "always",
                  borderTop: "2px solid #000",
                }}
              >
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody tbody style={{ height: "146px" }}>
                      <tr>
                        {[...Array(Area4.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "86px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: "center",
                            }}
                          >
                            <>{Area4[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              width: index != 0 ? "auto" : "33%",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandlePeopleListsed(e, "peolplesexample");
                                }}
                                value={peolples.peolplesexample.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandlePeopleListsed(e, "peolplesexample");
                                    }}
                                    value={peolples.peolplesexample.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandlePeopleListsed(e, "peolplesexample");
                                    }}
                                    value={peolples.peolplesexample.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    name="fourOne"
                    type="text"
                    onChange={(e) => {
                      HandlePeopleListsed(e, "peolplesexample");
                    }}
                    value={peolples.peolplesexample.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandlePeopleListsed(e, "peolplesexample");
                                }}
                                value={peolples.peolplesexample.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandlePeopleListsed(e, "peolplesexample");
                                    }}
                                    value={peolples.peolplesexample.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandlePeopleListsed(e, "peolplesexample");
                                    }}
                                    value={peolples.peolplesexample.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ----------------------People (Examples)------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Peoplelist.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "186px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Peoplelist[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "186px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandlePeopleListsed(e, "PeopleStability");
                                  }}
                                  value={peolples.PeopleStability.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "186px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandlePeopleListsed(
                                          e,
                                          "PeopleStability"
                                        );
                                      }}
                                      value={peolples.PeopleStability.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "186px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandlePeopleListsed(
                                          e,
                                          "PeopleStability"
                                        );
                                      }}
                                      value={peolples.PeopleStability.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "187px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandlePeopleListsed(e, "PeopleStability");
                    }}
                    value={peolples.PeopleStability.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "186px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandlePeopleListsed(e, "PeopleStability");
                                  }}
                                  value={peolples.PeopleStability.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "186px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandlePeopleListsed(
                                          e,
                                          "PeopleStability"
                                        );
                                      }}
                                      value={peolples.PeopleStability.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "186px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandlePeopleListsed(
                                          e,
                                          "PeopleStability"
                                        );
                                      }}
                                      value={peolples.PeopleStability.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Peoplelist1.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "187px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Peoplelist1[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "187px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandlePeopleListsed(e, "GoalSheets");
                                  }}
                                  value={peolples.GoalSheets.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "187px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandlePeopleListsed(e, "GoalSheets");
                                      }}
                                      value={peolples.GoalSheets.secondOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "187px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandlePeopleListsed(e, "GoalSheets");
                                      }}
                                      value={peolples.GoalSheets.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "187px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandlePeopleListsed(e, "GoalSheets");
                    }}
                    value={peolples.GoalSheets.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "187px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandlePeopleListsed(e, "GoalSheets");
                                  }}
                                  value={peolples.GoalSheets.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "187px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandlePeopleListsed(e, "GoalSheets");
                                      }}
                                      value={peolples.GoalSheets.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "187px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandlePeopleListsed(e, "GoalSheets");
                                      }}
                                      value={peolples.GoalSheets.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* -----------------------Last  Empty datas------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>

              {/* ----------------------------------Projects / Initiatives----------------- */}

              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody tbody style={{ height: "146px" }}>
                      <tr>
                        {[...Array(Area5.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "258px",
                              width: index != 0 ? "50%" : "31%",
                              //  width:"50",
                              textAlign: "center",
                            }}
                          >
                            <>{Area5[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              width: index != 0 ? "auto" : "33%",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "258px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleProjectsInitiativesListsed(
                                    e,
                                    "ProjectsInitiativesdata"
                                  );
                                }}
                                value={
                                  ProjectsInitiatives.ProjectsInitiativesdata
                                    .firstOne
                                }
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "ProjectsInitiativesdata"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives
                                        .ProjectsInitiativesdata.secondOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "ProjectsInitiativesdata"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives
                                        .ProjectsInitiativesdata.thirdOne
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    name="fourOne"
                    type="text"
                    onChange={(e) => {
                      HandleProjectsInitiativesListsed(
                        e,
                        "ProjectsInitiativesdata"
                      );
                    }}
                    value={ProjectsInitiatives.ProjectsInitiativesdata.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "258px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleProjectsInitiativesListsed(
                                    e,
                                    "ProjectsInitiativesdata"
                                  );
                                }}
                                value={
                                  ProjectsInitiatives.ProjectsInitiativesdata
                                    .fiveth
                                }
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "ProjectsInitiativesdata"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives
                                        .ProjectsInitiativesdata.sixOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "ProjectsInitiativesdata"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives
                                        .ProjectsInitiativesdata.seventh
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area5content.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "258px",
                              width: index != 0 ? "50%" : "31%",
                              //width:"50%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area5content[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                       
                          return ( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 0 ? "1px solid #000" : "none",

                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "258px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleProjectsInitiativesListsed(
                                    e,
                                    "Implementationdatas"
                                  );
                                }}
                                value={
                                  ProjectsInitiatives.Implementationdatas.firstOne
                                }
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "Implementationdatas"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives.Implementationdatas
                                        .secondOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "Implementationdatas"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives.Implementationdatas
                                        .thirdOne
                                    }
                                  />
                                )}
                              </>
                            )}

                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleProjectsInitiativesListsed(
                        e,
                        "Implementationdatas"
                      );
                    }}
                    value={ProjectsInitiatives.Implementationdatas.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {

return ( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "258px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleProjectsInitiativesListsed(
                                    e,
                                    "Implementationdatas"
                                  );
                                }}
                                value={
                                  ProjectsInitiatives.Implementationdatas.fiveth
                                }
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "Implementationdatas"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives.Implementationdatas.sixOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleProjectsInitiativesListsed(
                                        e,
                                        "Implementationdatas"
                                      );
                                    }}
                                    value={
                                      ProjectsInitiatives.Implementationdatas.seventh
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
)
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area5content01.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "258px",
                              // width: index != 0 ? "50%" : "auto",
                              width: index != 0 ? "50%" : "31%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area5content01[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "258px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleProjectsInitiativesListsed(
                                      e,
                                      "Hiringand"
                                    );
                                  }}
                                  value={ProjectsInitiatives.Hiringand.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "Hiringand"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.Hiringand.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "Hiringand"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.Hiringand.thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleProjectsInitiativesListsed(e, "Hiringand");
                    }}
                    value={ProjectsInitiatives.Hiringand.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "258px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleProjectsInitiativesListsed(
                                      e,
                                      "Hiringand"
                                    );
                                  }}
                                  value={ProjectsInitiatives.Hiringand.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "Hiringand"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.Hiringand.sixOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "Hiringand"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.Hiringand.seventh
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area5content02.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "258px",
                              // width: index != 0 ? "50%" : "auto",
                              width: index != 0 ? "50%" : "31%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area5content02[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "259px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleProjectsInitiativesListsed(
                                      e,
                                      "ImplementationofVariable"
                                    );
                                  }}
                                  value={
                                    ProjectsInitiatives.ImplementationofVariable
                                      .firstOne
                                  }
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "259px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "ImplementationofVariable"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives
                                          .ImplementationofVariable.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "259px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "ImplementationofVariable"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives
                                          .ImplementationofVariable.thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleProjectsInitiativesListsed(
                        e,
                        "ImplementationofVariable"
                      );
                    }}
                    value={ProjectsInitiatives.ImplementationofVariable.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "259px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleProjectsInitiativesListsed(
                                      e,
                                      "ImplementationofVariable"
                                    );
                                  }}
                                  value={
                                    ProjectsInitiatives.ImplementationofVariable
                                      .fiveth
                                  }
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "259px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "ImplementationofVariable"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives
                                          .ImplementationofVariable.sixOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "259px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "ImplementationofVariable"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives
                                          .ImplementationofVariable.seventh
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area5content03.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "258px",
                              //    width: index != 0 ? "50%" : "auto",
                              width: index != 0 ? "50%" : "31%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area5content03[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "258px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleProjectsInitiativesListsed(
                                      e,
                                      "StatutoryAudit"
                                    );
                                  }}
                                  value={
                                    ProjectsInitiatives.StatutoryAudit.firstOne
                                  }
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "StatutoryAudit"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.StatutoryAudit
                                          .secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "StatutoryAudit"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.StatutoryAudit
                                          .thirdOne
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleProjectsInitiativesListsed(e, "StatutoryAudit");
                    }}
                    value={ProjectsInitiatives.StatutoryAudit.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "258px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleProjectsInitiativesListsed(
                                      e,
                                      "StatutoryAudit"
                                    );
                                  }}
                                  value={
                                    ProjectsInitiatives.StatutoryAudit.fiveth
                                  }
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "StatutoryAudit"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.StatutoryAudit
                                          .sixOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "258px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleProjectsInitiativesListsed(
                                          e,
                                          "StatutoryAudit"
                                        );
                                      }}
                                      value={
                                        ProjectsInitiatives.StatutoryAudit
                                          .seventh
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              {/* -----------------------Last  Empty datas------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>

              {/* ----------------------------------Finance (Examples)----------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody tbody style={{ height: "146px" }}>
                      <tr>
                        {[...Array(Area6.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "86px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: "center",
                            }}
                          >
                            <>{Area6[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => { 
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              width: index != 0 ? "auto" : "33%",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(
                                    e,
                                    "FinanceInitialState"
                                  );
                                }}
                                value={Finance.Financelist.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "FinanceInitialState"
                                      );
                                    }}
                                    value={Finance.Financelist.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "FinanceInitialState"
                                      );
                                    }}
                                    value={Finance.Financelist.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                       }
                  
                        
                        )}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px", border: "none" }}
                    name="fourOne"
                    onChange={(e) => {
                      HandleFinancelistsListsed(e, "FinanceInitialState");
                    }}
                    value={Finance.Financelist.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                           return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(
                                    e,
                                    "FinanceInitialState"
                                  );
                                }}
                                value={Finance.Financelist.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "FinanceInitialState"
                                      );
                                    }}
                                    value={Finance.Financelist.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "FinanceInitialState"
                                      );
                                    }}
                                    value={Finance.Financelist.seventh}
                                  />
                                )}
                              </>
                            )}{" "}
                          </td>
                          )  }
                        
                        
                        )}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ----------------------Inner Finance------------------------ */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area6conten1.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              //   height: "149px",
                              height: "258px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area6conten1[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "258px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(
                                    e,
                                    "ImplementationofaFinance"
                                  );
                                }}
                                value={
                                  Finance.ImplementationofaFinance.firstOne
                                }
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "ImplementationofaFinance"
                                      );
                                    }}
                                    value={
                                      Finance.ImplementationofaFinance.secondOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "ImplementationofaFinance"
                                      );
                                    }}
                                    value={
                                      Finance.ImplementationofaFinance.thirdOne
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px", border: "none" }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleFinancelistsListsed(e, "ImplementationofaFinance");
                    }}
                    value={Finance.ImplementationofaFinance.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {

                          return ( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "258px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(
                                    e,
                                    "ImplementationofaFinance"
                                  );
                                }}
                                value={Finance.ImplementationofaFinance.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "ImplementationofaFinance"
                                      );
                                    }}
                                    value={
                                      Finance.ImplementationofaFinance.sixOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "258px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "ImplementationofaFinance"
                                      );
                                    }}
                                    value={
                                      Finance.ImplementationofaFinance.seventh
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>

                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area6conten2.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "257px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area6conten2[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "257px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(e, "Achievean");
                                }}
                                value={Finance.Achievean.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "257px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(e, "Achievean");
                                    }}
                                    value={Finance.Achievean.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "257px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(e, "Achievean");
                                    }}
                                    value={Finance.Achievean.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleFinancelistsListsed(e, "Achievean");
                    }}
                    value={Finance.Achievean.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "259px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleFinancelistsListsed(e, "Achievean");
                                  }}
                                  value={Finance.Achievean.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "259px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleFinancelistsListsed(
                                          e,
                                          "Achievean"
                                        );
                                      }}
                                      value={Finance.Achievean.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "259px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleFinancelistsListsed(
                                          e,
                                          "Achievean"
                                        );
                                      }}
                                      value={Finance.Achievean.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area6conten3.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "259px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area6conten3[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "259px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(e, "EnsureTax");
                                }}
                                value={Finance.EnsureTax.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "259px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(e, "EnsureTax");
                                    }}
                                    value={Finance.EnsureTax.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "259px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(e, "EnsureTax");
                                    }}
                                    value={Finance.EnsureTax.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px",  }}
                    type="text"
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "259px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(e, "ensureTotal");
                                }}
                                value={Finance.ensureTotal.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "259px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "ensureTotal"
                                      );
                                    }}
                                    value={Finance.ensureTotal.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "259px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "ensureTotal"
                                      );
                                    }}
                                    value={Finance.ensureTotal.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area6conten4.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "253px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area6conten4[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "253px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(
                                    e,
                                    "TreasuryIncome"
                                  );
                                }}
                                value={Finance.TreasuryIncome.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "253px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "TreasuryIncome"
                                      );
                                    }}
                                    value={Finance.TreasuryIncome.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "253px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "TreasuryIncome"
                                      );
                                    }}
                                    value={Finance.TreasuryIncome.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "259px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleFinancelistsListsed(e, "EnsureTax");
                    }}
                    value={Finance.EnsureTax.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "253px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(e, "EnsureTax");
                                }}
                                value={Finance.EnsureTax.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "253px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(e, "EnsureTax");
                                    }}
                                    value={Finance.EnsureTax.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "253px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(e, "EnsureTax");
                                    }}
                                    value={Finance.EnsureTax.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area6conten5.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "227px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area6conten5[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              <input
                                style={{ width: "100%", height: "230px" }}
                                type="text"
                              />
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "230px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleFinancelistsListsed(e, "TreasuryIncome");
                    }}
                    value={Finance.TreasuryIncome.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "227px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleFinancelistsListsed(
                                    e,
                                    "TreasuryIncome"
                                  );
                                }}
                                value={Finance.TreasuryIncome.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "227px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "TreasuryIncome"
                                      );
                                    }}
                                    value={Finance.TreasuryIncome.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "227px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleFinancelistsListsed(
                                        e,
                                        "TreasuryIncome"
                                      );
                                    }}
                                    value={Finance.TreasuryIncome.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ----------------------Finance (Examples)--End----------------------- */}
              {/* -----------------------Last  Empty datas------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>

              {/* ----------------------Customer----------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody tbody style={{ height: "146px" }}>
                      <tr>
                        {[...Array(Area7.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "86px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: "center",
                            }}
                          >
                            <>{Area7[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => 
                        { 
                           return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              width: index != 0 ? "auto" : "33%",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleCustomerListsed(e, "Customerlist");
                                }}
                                value={Customer.Customerlist.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(e, "Customerlist");
                                    }}
                                    value={Customer.Customerlist.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(e, "Customerlist");
                                    }}
                                    value={Customer.Customerlist.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>

                           )   }
                        )}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    name="fourOne"
                    onChange={(e) => {
                      HandleCustomerListsed(e, "Customerlist");
                    }}
                    value={Customer.Customerlist.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) =>{ 
                        return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleCustomerListsed(e, "Customerlist");
                                }}
                                value={Customer.Customerlist.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "Customerlist"
                                      );
                                    }}
                                    value={Customer.Customerlist.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "Customerlist"
                                      );
                                    }}
                                    value={Customer.Customerlist.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                           )   }
                        
                        )}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* ----------------------Inner Customer------------------------ */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area7content1.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area7content1[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>


                

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleCustomerListsed(e, "CustomerConnect");
                                }}
                                value={Customer.CustomerConnect.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerConnect"
                                      );
                                    }}
                                    value={Customer.CustomerConnect.secondOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerConnect"
                                      );
                                    }}
                                    value={Customer.CustomerConnect.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleCustomerListsed(e, "CustomerConnect");
                    }}
                    value={Customer.CustomerConnect.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleCustomerListsed(
                                    e,
                                    "CustomerConnect"
                                  );
                                }}
                                value={Customer.CustomerConnect.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerConnect"
                                      );
                                    }}
                                    value={Customer.CustomerConnect.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerConnect"
                                      );
                                    }}
                                    value={Customer.CustomerConnect.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
)
})}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area7content2.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "149px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area7content2[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleCustomerListsed(
                                    e,
                                    "CustomerSatisfaction"
                                  );
                                }}
                                value={Customer.CustomerSatisfaction.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerSatisfaction"
                                      );
                                    }}
                                    value={
                                      Customer.CustomerSatisfaction.secondOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerSatisfaction"
                                      );
                                    }}
                                    value={
                                      Customer.CustomerSatisfaction.thirdOne
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
                          )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "148px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleCustomerListsed(e, "CustomerSatisfaction");
                    }}
                    value={Customer.CustomerSatisfaction.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                           return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "149px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleCustomerListsed(
                                    e,
                                    "CustomerSatisfaction"
                                  );
                                }}
                                value={Customer.CustomerSatisfaction.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerSatisfaction"
                                      );
                                    }}
                                    value={Customer.CustomerSatisfaction.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "149px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerSatisfaction"
                                      );
                                    }}
                                    value={
                                      Customer.CustomerSatisfaction.seventh
                                    }
                                  />
                                )}
                              </>
                            )}
                          </td>
                           )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area7content3.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "227px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area7content3[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          //console.log(dataVal2, "as");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "227px" }}
                                  type="text"
                                  name="firstOne"
                                  onChange={(e) => {
                                    HandleCustomerListsed(
                                      e,
                                      "CustomerAccounts"
                                    );
                                  }}
                                  value={Customer.CustomerAccounts.firstOne}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "227px" }}
                                      type="text"
                                      name="secondOne"
                                      onChange={(e) => {
                                        HandleCustomerListsed(
                                          e,
                                          "CustomerAccounts"
                                        );
                                      }}
                                      value={
                                        Customer.CustomerAccounts.secondOne
                                      }
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "227px" }}
                                      type="text"
                                      name="thirdOne"
                                      onChange={(e) => {
                                        HandleCustomerListsed(
                                          e,
                                          "CustomerAccounts"
                                        );
                                      }}
                                      value={Customer.CustomerAccounts.thirdOne}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "230px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleCustomerListsed(e, "CustomerAccounts");
                    }}
                    value={Customer.CustomerAccounts.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                          ///console.log(datas3, "WQqwd");
                          return (
                            <td
                              key={index}
                              style={{
                                borderRight:
                                  index != 1 ? "1px solid #000" : "none",
                                borderLeft: "1px solid #000",
                                fontSize: "20px",
                              }}
                            >
                              {index == 0 ? (
                                <input
                                  style={{ width: "100%", height: "227px" }}
                                  type="text"
                                  name="fiveth"
                                  onChange={(e) => {
                                    HandleCustomerListsed(
                                      e,
                                      "CustomerAccounts"
                                    );
                                  }}
                                  value={Customer.CustomerAccounts.fiveth}
                                />
                              ) : (
                                <>
                                  {index != 1 ? (
                                    <input
                                      style={{ width: "100%", height: "227px" }}
                                      type="text"
                                      name="sixOne"
                                      onChange={(e) => {
                                        HandleCustomerListsed(
                                          e,
                                          "CustomerAccounts"
                                        );
                                      }}
                                      value={Customer.CustomerAccounts.sixOne}
                                    />
                                  ) : (
                                    <input
                                      style={{ width: "100%", height: "227px" }}
                                      type="text"
                                      name="seventh"
                                      onChange={(e) => {
                                        HandleCustomerListsed(
                                          e,
                                          "CustomerAccounts"
                                        );
                                      }}
                                      value={Customer.CustomerAccounts.seventh}
                                    />
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(Area7content4.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "227px",
                              width: index != 0 ? "50%" : "27%",
                              textAlign: index != 0 ? "center" : "right",
                            }}
                          >
                            <>{Area7content4[index].name}</>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                           return ( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "227px" }}
                                type="text"
                                name="firstOne"
                                onChange={(e) => {
                                  HandleCustomerListsed(
                                    e,
                                    "CustomerDashboards"
                                  );
                                }}
                                value={Customer.CustomerDashboards.firstOne}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "227px" }}
                                    type="text"
                                    name="secondOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerDashboards"
                                      );
                                    }}
                                    value={
                                      Customer.CustomerDashboards.secondOne
                                    }
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "227px" }}
                                    type="text"
                                    name="thirdOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerDashboards"
                                      );
                                    }}
                                    value={Customer.CustomerDashboards.thirdOne}
                                  />
                                )}
                              </>
                            )}
                          </td>
                           )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",
                    // display: "flex",
                  }}
                >
                  <input
                    style={{ width: "100%", height: "228px",  }}
                    type="text"
                    name="fourOne"
                    onChange={(e) => {
                      HandleCustomerListsed(e, "CustomerDashboards");
                    }}
                    value={Customer.CustomerDashboards.fourOne}
                  />
                </td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => {
                           return( 
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                            {index == 0 ? (
                              <input
                                style={{ width: "100%", height: "227px" }}
                                type="text"
                                name="fiveth"
                                onChange={(e) => {
                                  HandleCustomerListsed(
                                    e,
                                    "CustomerDashboards"
                                  );
                                }}
                                value={Customer.CustomerDashboards.fiveth}
                              />
                            ) : (
                              <>
                                {index != 1 ? (
                                  <input
                                    style={{ width: "100%", height: "227px" }}
                                    type="text"
                                    name="sixOne"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerDashboards"
                                      );
                                    }}
                                    value={Customer.CustomerDashboards.sixOne}
                                  />
                                ) : (
                                  <input
                                    style={{ width: "100%", height: "227px" }}
                                    type="text"
                                    name="seventh"
                                    onChange={(e) => {
                                      HandleCustomerListsed(
                                        e,
                                        "CustomerDashboards"
                                      );
                                    }}
                                    value={Customer.CustomerDashboards.seventh}
                                  />
                                )}
                              </>
                            )}
                          </td>
                           )
                        })}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              {/* -----------------------Last  Empty datas------------------------------- */}
              <tr>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={2}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(number10.length)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                              borderRight:
                                index != 1 ? "1px solid #000" : "none",
                              fontSize: "20px",
                              height: "19px",
                              width: index != 0 ? "50%" : "27%",
                            }}
                          >
                            <span style={{ height: "16px" }}>
                              <br />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={3}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",

                              fontSize: "20px",
                            }}
                          >

                              <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                      
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>

                <td
                  style={{
                    ///   width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                    // width: "3.7451%",

                    // display: "flex",
                  }}
                ></td>
                <td
                  style={{
                    width: "3.7451%",
                    border: "1px solid #000",
                    fontSize: "20px",
                  }}
                  colSpan={6}
                >
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        {[...Array(3)].map((_, index) => (
                          <td
                            key={index}
                            style={{
                                                            borderRight: index != 1 ?  "1px solid #000":"none",
                              borderLeft: "1px solid #000",
                              fontSize: "20px",
                            }}
                          >
                         
                            <span style={{ padding: "60px", height: "16px" }}>
                                <br />
                              </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table> */}
                </td>
              </tr>
            </tbody>
          </table>

          {/* -----------End------------------------ */}
        </div>
      </div>

      {/* ----------------End------Sheet---------------------------- */}
      <div
        className="UserButtons"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          marginBottom: "20px",
          alignItems: "center",
        }}
      >
        <button
          class="btn  SaveBtn"
          style={{ background: "#234492", color: "white" }}
          onClick={(e) => {
            HandleSubmit(e);
          }}
        >
          Generate
        </button>
      </div>
    </>
  );
});

export default AppraisalPerform;